import { render, staticRenderFns } from "./showSupply.vue?vue&type=template&id=4360a118&scoped=true"
import script from "./showSupply.vue?vue&type=script&lang=js"
export * from "./showSupply.vue?vue&type=script&lang=js"
import style0 from "./showSupply.vue?vue&type=style&index=0&id=4360a118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4360a118",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Supplies/Existence/showSupply.vue
// module id = 2144
// module chunks = 31